import { convertValues } from '~/util';

import { client } from './client/Client';

const convertCardAccountResponse = (response: any): CardAccount => {
  const cardAccount = convertValues<CardAccount>(response, undefined, {
    id: response.id || response.cardAccountId || response.card_account_id,
    cardProgramId: response.cardProgramId || response.card_program_id,
    bankAccountId: response.bankAccountId || response.bank_account_id,
    loanId: response.loanId || response.loan_id,
  });

  const rawCreatedAt = response.createdAt || response.created_at;
  if (rawCreatedAt) {
    cardAccount.createdAt = new Date(rawCreatedAt);
  }

  return cardAccount;
};

export interface CardAccount {
  id: string;
  cardProgramId: string;
  status: string;
  bankAccountId?: string;
  loanId?: string;
  createdAt?: Date;
}

interface ListCardAccountsResponse {
  cardAccounts: CardAccount[];
  hasMore: boolean;
}

export class CardAccountRepository {
  static async get(id: string): Promise<CardAccount> {
    return client
      .get<unknown, CardAccount>(`/cards/accounts/${id}`)
      .then((response) => convertCardAccountResponse(response));
  }

  static async listCardAccounts(): Promise<ListCardAccountsResponse> {
    try {
      return await client.get<unknown, ListCardAccountsResponse>('/cards/accounts').then((response) => ({
        cardAccounts: Array.isArray(response?.cardAccounts)
          ? response.cardAccounts.map((account) => convertCardAccountResponse(account))
          : [],
        hasMore: Boolean(response?.hasMore),
      }));
    } catch (error) {
      console.error('Failed to fetch card accounts:', error);
      return { cardAccounts: [], hasMore: false };
    }
  }

  static async suspend(id: string): Promise<CardAccount> {
    return client.patch<unknown, CardAccount>(`/cards/accounts/${id}/suspend`, {}).then((response) => {
      return convertCardAccountResponse(response);
    });
  }

  static async reinstate(id: string): Promise<CardAccount> {
    return client.patch<unknown, CardAccount>(`/cards/accounts/${id}/reinstate`, {}).then((response) => {
      return convertCardAccountResponse(response);
    });
  }

  static async close(id: string): Promise<CardAccount> {
    return client.patch<unknown, CardAccount>(`/cards/accounts/${id}/close`, {}).then((response) => {
      return convertCardAccountResponse(response);
    });
  }
}
